module.exports = __webpack_public_path__ + "img/Antonia&Stephan-02.2ed8fd8f.jpg";